import { useTheme } from "../../../context/theme";
import useForegroundVariantColor from "../../../styles/colors/surfaces/useForegroundVariantColor";
import { ResponsiveProp, Width } from "../../../types";
import { Box, Inline } from "../../layout";
import ToggleButtonOption, { ToggleOption } from "./ToggleButtonOption";

type Props<ValueT> = {
  selectedValue: ValueT;
  options: Array<ToggleOption<ValueT>>;
  onChange: (value: ValueT) => void;
  width?: ResponsiveProp<Width>;
};

export default function ToggleButton<ValueT = string>({
  options,
  selectedValue,
  onChange,
  width = "fit-content"
}: Props<ValueT>) {
  const theme = useTheme();

  const foregroundVariantColor = useForegroundVariantColor("1");

  const flexValues = options.map(() => "auto");

  return (
    <Box
      dataTest="ToggleButton"
      width={width}
      borderRadius="small"
      padding="xxsmall"
      backgroundColor={foregroundVariantColor}
      borderStyle="solid"
      borderWidth="xxxsmall"
      borderColor={theme["neutral-xLow-content"]}
    >
      <Inline space="small" flexValues={flexValues}>
        {options.map(({ label, value }: ToggleOption<ValueT>, index) => (
          <ToggleButtonOption<ValueT>
            key={index}
            selectedValue={selectedValue}
            onChange={onChange}
            label={label}
            value={value}
          />
        ))}
      </Inline>
    </Box>
  );
}
